/**
 * 中文字典(基准字典,en.ts 必须与之同构).
 *
 * 来源(旧项目 fastj/client/src/locales/lang/zh-cn.json,值逐字复制,不改写):
 * - app/route:门户需要的 key 子集
 * - inx/guideline/subject:完整迁移
 * - inx.filter / inx.pager:由旧字典顶层中文 key(等级/评分/儿童/… )归并而来,
 *   供门户筛选面板、排序条、分页器使用;文案与旧站一致
 */
const zh = {
  app: {
    login: '登录',
    logout: '退出登录',
    goLogin: '去登录',
    register: '注册',
    adminConsole: '管理后台',
    check: '确认',
    account: '用户名',
    password: '密码',
    newPassword: '新密码',
    captcha: '验证码',
    sendCaptcha: '发送验证码',
  },
  route: {
    home: '主页',
    login: '登录',
  },
  // ===== 认证页(P1.2 新增):登录 / 注册 / 找回密码 / 重置密码 =====
  auth: {
    loginTitle: '登录 TRUST',
    loginSubtitle: '循证标准注册与评价平台',
    account: '账号',
    accountPlaceholder: '用户名 / 邮箱 / 手机号',
    accountRequired: '请输入账号/邮箱/手机号',
    password: '密码',
    passwordRequired: '请输入密码',
    passwordPlaceholder: '密码',
    loginButton: '登 录',
    loginFailed: '登录失败',
    toRegister: '注册账号',
    toForgot: '忘记密码?',
    backToLogin: '返回登录',
    registerTitle: '注册 TRUST 账号',
    username: '用户名',
    usernamePlaceholder: '2-64 位字母、数字、_ - .',
    usernameRequired: '请输入用户名',
    email: '邮箱',
    emailPlaceholder: '用于找回密码(可选)',
    emailInvalid: '邮箱格式不正确',
    newPassword: '新密码',
    newPasswordPlaceholder: '至少 8 位,需含字母和数字',
    confirmPassword: '确认密码',
    confirmPasswordRequired: '请再次输入密码',
    confirmPasswordMismatch: '两次输入的密码不一致',
    registerButton: '注 册',
    registerFailed: '注册失败',
    forgotTitle: '找回密码',
    forgotTip: '输入用户名或邮箱,如果账号存在,我们会向其邮箱发送重置链接(30 分钟内有效)。',
    forgotButton: '发送重置链接',
    forgotSuccess: '如果账号存在,重置链接已发送到其邮箱,30 分钟内有效',
    resetTitle: '重置密码',
    resetTokenMissing: '链接无效:缺少 token 参数',
    resetButton: '重置密码',
    resetSuccess: '密码已重置,请用新密码登录',
    resetFailed: '重置失败',
  },
  inx: {
    title: '全球服务标准注册及循证评价平台',
    standard: {
      standardRanking: 'Standard Ranking',
    },
    header: {
      home: '首页',
      standardRanking: '标准排名',
      aboutUs: '关于我们',
      registerStandard: '注册标准',
      standardsLibrary: '标准库',
      myStandard: '我的标准',
    },
    toRegister: '去注册标准',
    aboutUs: {
      title: 'TRUST (Transparent Registry for Unified Standards and Testing) 国际循证标准首发宣传:',
      subTitle: '您好,欢迎来到TRUST国际循证标准网站',
      p1: 'TRUST国际循证标准由Campbell China Network(CCN)和衡水建辰教育科技中心联合发起。TRUST国际标准的研发严格遵循注册、研究、发布、评价、更新等环节,确保全过程的高质量管控,旨在为社会提供可信赖、可操作的高质量标准和指南,引领全球与中国的健康与社会服务走向更加公平、高效与可持续的发展路径。',
      p2: 'CCN是在国际 Campbell 协作网的指导下,由来自复旦大学、四川大学、武汉大学、兰州大学和南京理工大学等30余家顶尖循证团队组成,形成了一个跨学科的学术联盟。\n        我们可以为您提供标准注册功能,提供注册证明,同时页面可以浏览进行中的标准标题以避免重复工作。完成标准后,我们会组织相关专业团队对您的标准进行评价并展示相关分数及评级,协助您更规范的开展标准撰写工作。在标准检索库中,我们将提供最完善最全面的标准库供您检索及参考。',
      p3: '同时我们希望TRUST平台建设可以为标准带来更为科学透明的流程,以及更为清晰的标准完成过程。我们会加强行业组织专家在标准注册、研究、发布、评价、更新等环节的作用,以确保标准公平公正发布。',
      p4: '如何联系我们:注册完成后可在对话框联系管理员',
      p5: 'After registration, you can contact the administrator via the chat box.',
      privacyTitle: '隐私政策和使用条款说明:',
      ul1: '一:隐私政策',
      ul1l1: '1:我们在平台注册新账户时需要搜集您的相关信息其中包含:姓名、电子邮件、地址等。',
      ul1l2: '2:我们收集信息仅为方便您进行标准注册、研究、共享、评价等相关服务工作。',
      ul1l3: '3:我们并不与第三方共享您的私人信息',
      ul1l4: '4:您可以在登录主页内容修改您的个人信息',
      ul2: '二:使用条款:',
      ul2l1: '1:您在使用平台时是否同意条款内容',
      ul2l2: '2:您的责任是',
      ul2l2l1: '(1):合法使用网站内容,不违反任何法律法规,不进行非法活动或侵犯他人权益。',
      ul2l2l2: '(2):用户需要提供真实准确的信息,避免虚假信息或误导信息。',
      ul2l2l3: '(3):用户有责任保护其账户的信息和密码安全,不将其泄露第三方,并对其账户下活动负责。',
      ul2l2l4: '(4):用户尊重网站及其内容的知识产权、不擅自复制、发布或修改版权内容。',
      registerUrl: '点击注册:全球服务标准注册及循证评价平台',
      evaluation: {
        title: 'TRUST对于指南和标准的评估条目:',
        item1: {
          title: '一:是否处理利益冲突',
          entry1: '1 记录并说明指南制定过程中的利益冲突。',
        },
        item2: {
          title: '二:多学科团队的参与与代表性',
          entry1: '1 确保各相关学科代表全面参与。',
        },
        item3: {
          title: '三:是否基于研究证据',
          entry1: '1 系统方法检索证据:',
          entry2: '2 证据的纳排标准:',
          entry3: '3 证据质量的分级与评级:',
          entry4: '4 推荐强度系统:',
          entry5: '5 形成推荐意见时充分考虑和说明益处、副作用及危险:',
        },
        item4: {
          title: '四:是否进行多方共识',
          entry1: '1指南形成推荐意见时进行多方共识以收集意见:',
        },
        item5: {
          title: '五:是否包括推广及更新计划',
          entry1: '1 指南包含推广方法:',
          entry2: '2 指南包含后续更新计划:',
        },
        flow: {
          title: '评估流程:',
          content:
            '平台共享标准及指南首先由两个评估专家对其文本内容依据评估指标进行评价,当评分差距在三分以内时,两位专家依托平台对话功能展开沟通最终达成一致。当评分差距大于等于三分时,由第三位评估专家组组长重新评定。',
        },
      },
    },
    rank: {
      top100: 'TOP 100 排行榜',
      field1: '排名',
      field2: '名称',
      field3: '学科分类',
      field4: '指定机构',
      field5: '等级',
    },
    button: {
      search: '搜索',
    },
    tip: {
      search: '请输入标题,支持模糊查询',
      sort: '排序',
      date: '发布时间',
      score: '评分',
    },
    filter: {
      category: '类别',
      subject: '学科',
      population: '人群分类',
      edition: '版本',
      level: '等级',
      score: '评分',
      unrated: '未评分',
      typeStandard: '标准',
      typeGuideline: '指南',
      popChildren: '儿童',
      popElderly: '老年人',
      popWomen: '妇女',
      popTeenagers: '青少年',
      popOther: '其他',
      editionOriginal: '原版',
      editionUpdated: '更新',
      filter: '筛选',
      expand: '展开',
      collapse: '收起',
    },
    pager: {
      total: '共',
      current: '当前第',
    },
    // ===== 落地页全屏轮播(P0.8 新增,来源旧 inxguide-www 的 inx.www.*,值逐字复制)=====
    landing: {
      joinUs: '加入我们',
      c1Title: '标准注册',
      c1Subtitle: '注册您的标准,并得到全球认可',
      c1Button: '去注册',
      c2Title: '标准搜索',
      c2Subtitle: '搜索已发布的国际认证标准库',
      c2Button: '去搜索',
      c3Title: '标准排名',
      c3Subtitle: '已发布的排名榜单',
      c3Button: '去查看',
    },
  },
  guideline: {
    subject: '所属学科',
    journal: '发布杂志',
    organization: '制订机构',
    introduction: '介绍',
    regNo: '注册号',
    regTime: '注册时间',
    country: '国家',
    startDate: '开始时间',
    endDate: '结束时间',
    fundSource: '资金来源',
    originalLink: '原文链接',
    docDownload: '文档下载',
    ranking: '指南排名',
    more: '更多',
    rank: '排名',
    level: '等级',
    score: '评分',
    certificate: '证书',
    view: '查看',
    none: '无',
  },
  subject: {
    socialWork: '社会科学 - 社会工作',
    socialPolicy: '社会科学 - 社会政策',
    psychology: '社会科学 - 心理学',
    education: '社会科学 - 教育',
    management: '社会科学 - 管理',
    economics: '社会科学 - 经济学',
    socialOther: '社会科学 - 其他',
    complementaryMedicine: '健康与医学 - 补充与替代医学',
    publicHealth: '健康与医学 - 公共卫生',
    clinicalMedicine: '健康与医学 - 临床医学',
    nursing: '健康与医学 - 护理',
    rehabilitationMedicine: '健康与医学 - 康复医学',
    integrativeCare: '健康与医学 - 整合护理',
  },
  // ===== 指南详情页保留能力文案(P0.7 新增):分享/状态机操作弹窗/加载态 =====
  guideDetail: {
    share: '分享',
    shareCopied: '链接已复制到剪贴板',
    copyPrompt: '请复制以下链接',
    loadFailed: '加载失败',
    confirmOp: '确认执行',
    currentStatus: '当前状态',
    remarkPlaceholder: '备注(可选),将记录到流转日志',
    opSuccess: '操作成功',
  },
  // ===== 三态搜索页(P0.3 新增):筛选树父分组名 + 自绘分页器单位文案 =====
  searchPage: {
    groupSocial: '社会科学',
    groupHealth: '健康与医学',
    pageUnit: '条',
    perPage: '/页',
    goto: '前往',
    pageSuffix: '页',
  },
  // ===== 【P1.9 新增】后台任务中心(/admin/tasks),zh/en 同构 =====
  admin: {
    tasks: {
      title: '任务中心',
      tabAll: '全部',
      tabTodo: '待办',
      tabDone: '已办',
      colType: '类型',
      colTitle: '标题',
      colStatus: '状态',
      colOperation: '操作',
      colTime: '时间',
      kindGuide: '指南',
      kindEvaluation: '评审单',
      kindFlowLog: '流转记录',
      bucketTodo: '待处理',
      bucketDone: '已办',
      emptyAll: '暂无任务',
      emptyTodo: '暂无待办任务',
      emptyDone: '暂无已办记录',
      status: {
        Waiting: '待提交',
        Apply: '已申请',
        Approved: '已批准',
        Rejected: '已驳回',
        Scored: '已评分',
        Leveled: '已定级',
      },
      stage: {
        Register: '注册',
        Sharing: '共享',
        Evaluation: '评价',
        Publish: '发布',
      },
      operation: {
        submit: '提交',
        approve: '审核通过',
        reject: '驳回',
        resubmit: '重新提交',
        request_rectify: '要求整改',
        submit_rectify: '提交整改',
        final_approve: '终审通过',
        system: '系统流转',
      },
    },
  },
  // ===== P1.4 动态字段配置(新增):注册表单扩展分组回退标题/详情页扩展块/必填校验 =====
  guideFields: {
    sectionTitle: '扩展信息',
    requiredMsg: '该字段为必填项',
  },
  // ===== 【P2.6 新增】新建指南查重(需求 #19):相似命中提示弹窗,zh/en 同构 =====
  duplicateCheck: {
    title: '发现相似指南',
    desc: '平台已存在以下相似指南,请确认并非重复注册;确认无误仍可继续创建。',
    similarity: '相似度',
    view: '查看',
    createAnyway: '仍要创建',
    cancel: '返回修改',
  },
  // ===== 【P3.2 新增】PDF 证据高亮查看器(需求 #54):工具条/证据命中/加载错误态,zh/en 同构 =====
  pdfViewer: {
    discoveryFailed: '暂时无法确认本地原文版本，请稍后重试。未访问生产文件。',
    discovering: '正在确认本地原文版本…',
    invalidRequest: '原文定位参数无效，请使用包含文件版本和有效页码的链接。',
    unavailable: '本地原文不可用或无权访问。未尝试访问生产文件。',
    versionChanged: '原文版本已变化，无法打开此引用所指的版本。请重新检索来源。',
    tooLarge: '原文超过本地阅读器的 32 MiB 限制。',
    loadFailed: '本地原文加载或校验失败，请稍后重试。',
    pageOutOfRange: '引用页码超出此版本 PDF 的范围，未自动跳转到其他页。',
    verifiedRendering: '原文版本已校验，正在渲染指定页…',
    verifiedRendered: '原文版本已校验，当前页已渲染。',
    externalOrigin: '访问外部原文',

    title: '原文',
    download: '下载 PDF',
    visitOrigin: '访问原文',
    noPdf: '未提供 PDF,请通过"访问原文"跳转查看',
    loading: 'PDF 加载中…',
    loadError: 'PDF 加载失败,可尝试"下载 PDF"查看',
    prevPage: '上一页',
    nextPage: '下一页',
    pageUnit: '页',
    zoomIn: '放大',
    zoomOut: '缩小',
    evidence: '证据定位',
    prevMatch: '上一处',
    nextMatch: '下一处',
    matchUnit: '处命中',
    searching: '正在全文检索证据片段…',
    notFound: '未在 PDF 中找到该证据片段',
  },
  // ===== 【P3.1 新增】详情页 AI 评审 Tab(需求 #13/#51):五维卡片 + 状态/空态,zh/en 同构 =====
  aiReview: {
    tabInfo: '指南信息',
    tabAI: 'AI 评审',
    loadFailed: 'AI 评审加载失败',
    empty: '暂无 AI 评审记录',
    emptyHint: '该指南尚未进行 AI 评审,完成后将在此展示五维评分与证据引用。',
    running: 'AI 评审进行中',
    failed: 'AI 评审失败',
    budgetExceeded: '评审预算熔断,请稍后重试',
    confidence: '置信度',
    reasoningSteps: '推理步骤',
    evidenceQuotes: '原文引用',
    riskFlags: '风险点',
    pagePrefix: '第',
    pageSuffix: '页附近',
    scoreSuffix: '/ 10',
    notScored: '未评分',
    reviewedAt: '评审时间',
    model: '模型',
    dim: {
      coi: '利益冲突',
      multidisciplinary: '多学科参与',
      evidence: '证据基础',
      consensus: '共识方法',
      dissemination: '传播实施',
    },
    status: {
      queued: '排队中',
      parsing: '解析 PDF',
      scoring: '打分中',
      done: '已完成',
      failed: '失败',
      budget_exceeded: '预算熔断',
    },
  },
  // ===== 【P3.6 新增】详情页右侧「相似指南」卡(需求 #53),zh/en 同构 =====
  similarGuides: {
    title: '相似指南',
  },
}

export default zh
export type Messages = typeof zh
